import React from 'react';
import styles from "../../../styles/pages/DocumentationPage/components/Tabs.module.css";

export const Tabs = ({ activeTab, setActiveTab }) => {
    return (
        <div className={styles.container}>
            <div className={styles.navigation}>
                <button
                    onClick={() => setActiveTab("PostLead")}
                    className={`${styles.tabButton} ${activeTab === "PostLead" ? styles.active : ''}`}
                >
                    PostLead
                </button>
                <button
                    onClick={() => setActiveTab("GetLead")}
                    className={`${styles.tabButton} ${activeTab === "GetLead" ? styles.active : ''}`}
                >
                    GetLead
                </button>
                <button
                    onClick={() => setActiveTab("CreateDeposit")}
                    className={`${styles.tabButton} ${activeTab === "CreateDeposit" ? styles.active : ''}`}
                >
                    CreateDeposit
                </button>
                <button
                    onClick={() => setActiveTab("CreateWithdrawal")}
                    className={`${styles.tabButton} ${activeTab === "CreateWithdrawal" ? styles.active : ''}`}
                >
                    CreateWithdrawal
                </button>
                <button
                    onClick={() => setActiveTab("GetTransaction")}
                    className={`${styles.tabButton} ${activeTab === "GetTransaction" ? styles.active : ''}`}
                >
                    GetTransaction
                </button>
                <button
                    onClick={() => setActiveTab("GetBalance")}
                    className={`${styles.tabButton} ${activeTab === "GetBalance" ? styles.active : ''}`}
                >
                    GetBalance
                </button>
            </div>
        </div>
    );
};
